'use strict';
module.exports = require('./Dialog.vue');


//////////////////
// WEBPACK FOOTER
// ./~/primevue/dialog/index.js
// module id = 12
// module chunks = 1